import React from 'react';

import EditSelectPipelineStage from '../stage/EditSelectPipelineStage';
import EditSelect from '../../select/EditSelect';

const EditLineAndStage = ({ pipeline, setPipeline, pipelineStage, setPipelineStage, pipelines }) => {
    return (
        <div className='crm-editable-field-wrapper'>
            <div className='description'>Pipeline</div>
            <EditSelect iconName='pipeline' value={pipeline} setValue={(option) => setPipeline(option)} options={pipelines} />
            <div className='description'>Pipeline stage</div>
            <EditSelectPipelineStage value={pipelineStage} setValue={(stage) => setPipelineStage(stage)} stages={pipeline.pipelineStages} />
        </div>
    );
};

export default EditLineAndStage;
